<mat-select [formControl]="id_type" class="form-control">

    <mat-option [value]="null"></mat-option>
    
    <mat-option [value]="idTypes.SystemCode">{{ 'site.site' | translate }}</mat-option>
    <mat-option [value]="idTypes.UserCode">{{ 'site.user_site' | translate }}</mat-option>
    <mat-option [value]="idTypes.OwnerCode">{{ 'site.owner_site' | translate }}</mat-option>

</mat-select>
